import React from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'

import './ChequePaymentContent.css'

const ChequePaymentContent = ({ t }) =>
  <div className="cheque-container">
    <span className="cheque-title">{t('common:payment:cheque:instruction')}</span>
    <ul className="cheque-list">
      <li><span>{t('common:payment:address:consignee')}</span></li>
      <li><span>{t('common:payment:address:street')}</span></li>
      <li><span>{t('common:payment:address:postal_code_city')}</span></li>
    </ul>
  </div>

ChequePaymentContent.propTypes = { t: func }

export default translate()(ChequePaymentContent)



// WEBPACK FOOTER //
// ./src/components/customer/wallet/payments/cheque/ChequePaymentContent.js